<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Information Technology"
                   :links="[{title:'Home', url:'/'},{title:'Faculty'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="4"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">Faculty</div>
            <faculty-card class="mb-5"
                          v-for="(faculty, index) in facultyList"
                          :key="index"
                          :faculty="faculty"
                          :dir="dirName"></faculty-card>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/it/Sidebar";
import FacultyCard from "@/components/FacultyCard";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Faculty",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    FacultyCard
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      dirName: 'it',
      facultyList: [
        {
          name: 'Prof. Rokade P. P.',
          cv: 'test.pdf',
          image: 'rokade_p_p',
          designation: 'HOD & Assistant Professor',
          qualification: 'M.Tech (Computer), Ph.D.*',
          experience: '16Yrs',
          specialization: ' Data Science',
          contact: '8999049809',
          email: ' prakashrokade2005@gmail.com'
        },
        {
          name: 'Prof. Waghmare A. I. ',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: 'Assistant Professor',
          qualification: 'M. E (Computer)',
          experience: '14 Yrs',
          specialization: ' Network Security',
          contact: '9422450430',
          email: ' arunwaghmare@gmail.com'
        },
        {
          name: 'Prof. Abhale B. A. ',
          cv: 'test',
          image: 'abhale_ba',
          designation: 'Assistant Professor',
          qualification: 'M. Tech (CSE)',
          experience: '14 Yrs',
          specialization: 'Software Testing',
          contact: '9096549454',
          email: 'atul.abhale@gmail.com'
        },
        {
          name: 'Prof. Shelake N. L.',
          cv: 'test',
          image: 'shelake_nl',
          designation: 'Assistant Professor',
          qualification: 'ME (Computer)',
          experience: '10 Yrs',
          specialization: 'Image Processing',
          contact: '9422512074',
          email: 'nitinshelake2011@gmail.com'
        },
        {
          name: 'Mr. Gaikwad D. S.',
          cv: 'test',
          image: 'gaikwad_ds',
          designation: ' Asst. Prof.',
          qualification: ' ME Computer',
          experience: ' 01 Year',
          specialization: 'Image Processing',
          contact: '7798550523',
          email: 'dnyanesh.gd@gmail.com'
        },
        {
          name: 'Ms. Pawar M. D.',
          cv: 'test',
          image: 'pawar_md',
          designation: 'Asst. Prof.',
          qualification: 'ME Computer',
          experience: '2 yrs ( 1 Industry + 1 Teaching)',
          specialization: 'Image Processing',
          contact: '8446038962',
          email: 'mayupawar123@gmail.com'
        },
        {
          name: 'Mr. Pawar Y. B.',
          cv: 'test',
          image: 'pawar_yb',
          designation: 'Asst. Prof.',
          qualification: 'ME Computer',
          experience: '13 years 9 months',
          specialization: 'computer networks ',
          contact: '7385768414',
          email: ' yogesh03071987@gmail.com'
        },
        {
          name: 'Ms. Sarode S.V',
          cv: 'test',
          image: 'sarode_sv',
          designation: 'Assistant Professor',
          qualification: 'ME Computer',
          experience: '06 Months',
          specialization: 'Data Science',
          contact: '8830647270',
          email: 'sarusarode87@gmail.com'
        },
        {
          name: 'Mr. Tathe S. G.',
          cv: 'test',
          image: 'tathe_sg',
          designation: ' Assistant Professor',
          qualification: 'ME *',
          experience: ' 08 years',
          specialization: ' Data Science',
          contact: '8788583429',
          email: 'sachin.tathe@gmail.com'
        },
        {
          name: 'Ms. Thombare N. S. ',
          cv: 'test',
          image: 'thombare_ns',
          designation: '  Teaching Assistant ',
          qualification: 'BE Computer',
          experience: '0.1',
          specialization: ' Java',
          contact: '7517827992',
          email: 'nayanathombare29@gmail.com'
        },
        {
          name: 'Ms. Borbane R. B.',
          cv: 'test',
          image: 'borbane_rb',
          designation: 'Technical Assistant',
          qualification: 'BCS',
          experience: '01 Yrs',
          specialization: 'none',
          contact: '9322175056',
          email: 'raniborbane99@gmail.com'
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
